import { useState } from "react";

export default function usePaginationWithProfileType(
  initialPage = 1,
  initialType = 1,
) {
  const [page, setPage] = useState(initialPage);
  const [profileType, setProfileType] = useState(initialType);

  return {
    page,
    setPage,
    profileType,
    setProfileType,
  };
}
